import * as React from 'react';
import TimelineCircleImage from '../../../../timeline/TimelineCircleImage/TimelineCircleImage';

const Image = require('../../../../../assets/img/timeline/modal/2017-forbes.jpg');

const JohnForbesContent = () => {
    return (
        <>
            <TimelineCircleImage image={Image} />
            <h4>
                Professor John Forbes AM retires as Director of Research
            </h4>
            <p>
                Professor John Forbes AM, a founder of Breast Cancer Trials (BCT), retires from his position of Director of Research after a career of more than 40 years. During that time, he was the National Group Coordinator from 1984-2008, a BCT Board Director from 1991-2008 and 2013-2016, and was the BCT’s Director of Research from 2008-2017.
            </p>
        </>
    );
}

export default JohnForbesContent;